import { EventEmitter } from "@angular/core";
import { AdvertModel } from "../../shared/models/advert.model";
import { ColumnModel } from "../../shared/models/column.model";
export class AdvertBuildData{
    module = {
        name: "Advert",
        new_name: "advert",
        has_dot_menu: true,
        icon:'fa-ad',
        permission:'advert'
    }
    
    onReload: EventEmitter < boolean > = new EventEmitter<boolean>();//Forces Reload of codeblack table on emit.
    rowFunction = (row:AdvertModel) => {//Generates Row for codeblack-table
        return AdvertModel.getListRow(row);
    }
    
    columns:ColumnModel[] = [
        {
            title: "Id",
            prop: "id",
            flex_grow: 1,
            row_accessor: "id",
            class:""//force-flex force-flex-end
        },
        {
            title: "Title",
            prop: "title",
            flex_grow: 4,
            row_accessor: "title",
        }
    ];

    constructor(){
        for(let col of this.columns){
            col = new ColumnModel(col);
        }
    }

}